import { render, staticRenderFns } from "./our-experience.vue?vue&type=template&id=2987e3ec&scoped=true"
import script from "./our-experience.vue?vue&type=script&lang=js"
export * from "./our-experience.vue?vue&type=script&lang=js"
import style0 from "./our-experience.vue?vue&type=style&index=0&id=2987e3ec&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2987e3ec",
  null
  
)

export default component.exports